export default __webpack_public_path__ + "static/media/office3full.428ce6e2.jpg";